export default (state = {}, action) => {
  switch (action.type) {
    case 'SET_FORMAL_NOTICE':
      return {
        ...state,
        ...action.data
      }
    case 'CLEAR_FORMAL_NOTICE':
      return {}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/formalNotice-reducer.js